module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activityCard"
  }, [_c('div', {
    staticClass: "card",
    class: {
      'large': (_vm.size === 'large'), 'small': (_vm.size === 'small')
    },
    on: {
      "click": function($event) {
        _vm.goToActivity()
      }
    }
  }, [(typeof _vm.activity.images !== 'undefined') ? _c('div', {
    staticClass: "cardImage",
    class: {
      'large': (_vm.size === 'large'), 'small': (_vm.size === 'small')
    }
  }, [_c('div', {
    staticClass: "img",
    style: (("background-image: url(" + (_vm.activity.images.data[0].thumbnail_path) + ")"))
  }), _vm._v(" "), (_vm.activity.base_price) ? _c('div', {
    staticClass: "basePrice"
  }, [_vm._v(_vm._s(_vm.t('from')) + " " + _vm._s(_vm.activity.base_price) + " € "), (_vm.activity.is_priced_per_occurrence) ? _c('span', [_vm._v("/ " + _vm._s(_vm.t('group')))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    class: {
      'large': (_vm.size === 'large'), 'small': (_vm.size === 'small')
    }
  }, [_c('OverviewIcons', {
    attrs: {
      "activity": _vm.activity,
      "with-shadow": true
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.activity.translations[_vm.language].name))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [(_vm.headerIcons) ? _c('DescriptionHeader', {
    attrs: {
      "activity": _vm.activity
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n            " + _vm._s(_vm.activity.translations[_vm.language].description) + "\n          ")]), _vm._v(" "), _c('p')], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5bf69305", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bf69305"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/ActivityCard.vue
// module id = 780
// module chunks = 3